const modalsDataSelector = state => state.ui.modals;
export const modalTypeSelector = state => modalsDataSelector(state).modalType;
export const modalPropsSelector = state => modalsDataSelector(state).modalProps;
